module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/the_way2-8d45ad257c23242fec168c308fff0dc3.svg";